import React from 'react';
import Translation from "../../../../commons/i18n/Translation";
import { CustomSelect } from "../../../../commons/index";
import Select from "react-select";
import Constants from "../../../configurations/Constants";
import { CommonsConstants } from "../../../../commons/index";

import Svg from "../../../../../svg/Svg";

export default class MobileSearchFilters extends React.Component {

    constructor(props) {
        super(props);
    }

    isEvent = () => this.props.contentType === Constants.CONTENT_FILTER.EVENT;

    onResetFilters = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onResetFilters();
    };

    renderLocality = () => (
        <div className="mywort-filters__group">
            <div className="mywort-filters__input">
                <CustomSelect
                    searchPromptText={Translation.translate("search.starttyping")}
                    searchingText={Translation.translate("search.loading")}
                    async debounceTime={500}
                    placeholder={Translation.translate("commons.locality")}
                    value={this.props.locality}
                    onChange={this.props.onChangeLocality}
                    loadOptions={(input, asyncSelectCallback) => this.props.searchLocality(input, asyncSelectCallback)}
                    valueKey="id"
                    labelKey="name"
                    minimumInput={2}
                />
            </div>
        </div>
    );

    renderGroup = () => (
        <div className="mywort-filters__group">
            <div className="mywort-filters__input">
                <CustomSelect
                    searchPromptText={Translation.translate("search.starttyping")}
                    searchingText={Translation.translate("search.loading")}
                    async debounceTime={500}
                    placeholder={Translation.translate("commons.group")}
                    value={this.props.group}
                    onChange={this.props.onChangeGroup}
                    loadOptions={(input, asyncSelectCallback) => this.props.searchGroup(input, asyncSelectCallback)}
                    valueKey="id"
                    labelKey="name"
                    minimumInput={2}
                />
            </div>
        </div>
    );

    renderEventDate = () => {
        return <div className="mywort-filters__group">
                <div className="input-group date ">
                    <input type="date"
                           defaultValue={this.props.eventDate}
                           onChange={this.props.onChangeEventDate}
                           className="mywort-filters__input"
                           placeholder={Translation.translate("search.filters.date.placeholder")}/>
                    <span className="input-group-addon"><Svg id="fa-calendar" className="mywort-filters__group__svg"></Svg></span>
                </div>
            </div>
    };

    renderLanguage = () => (
        <div className="mywort-filters__group">
            <div className="mywort-filters__input">
                <Select
                    aria-label={Translation.translate("commons.language")}
                    placeholder={Translation.translate("commons.language")}
                    value={this.props.language}
                    onChange={this.props.onChangeLanguage}
                    options={CommonsConstants.LANGUAGES}
                    valueKey="id"
                    labelKey="name"
                    searchable={false}
                    clearable={true}
                />
            </div>
        </div>
    );


    render = () => (
        <div className="mywort-filters">
            { this.isEvent() ? this.renderEventDate() : null }
            { this.renderLocality() }
            { this.renderGroup() }
            { this.renderLanguage() }
            <div className="mywort-filters__section u-text-center">
                <a href="" className="mywort-filters__reset-filters mywort-link mywort-link--gray" onClick={this.onResetFilters}>
                    {Translation.translate("search.filters.reset")}
                </a>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/mobile/MobileSearchFilters.jsx